import {
  IAssessmentsRetakeReasonsRawData,
  IAutoAssessmentsRetakeReasonsFormattedData,
} from '../types';

export function formatAutoAssessmentsRetakeReasonsResponse(
  response: IAssessmentsRetakeReasonsRawData[]
): IAutoAssessmentsRetakeReasonsFormattedData[] {
  const formattedReasons = response.map((item) => {
    // eslint-disable-next-line camelcase
    const { _id, reason, reason_ar, description, description_ar } = item;

    return {
      reasonId: _id,
      reason: {
        en: reason,
        // eslint-disable-next-line camelcase
        ar: reason_ar || reason,
      },
      description: {
        en: description,
        // eslint-disable-next-line camelcase
        ar: description_ar || description,
      },
    };
  });

  return formattedReasons;
}
